import { render, staticRenderFns } from "./Giveaway.vue?vue&type=template&id=4e12f8b9&"
import script from "./Giveaway.vue?vue&type=script&lang=js&"
export * from "./Giveaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports